<template>
    <div class="dropdown course-container__reservation-sidebar__timepicker__dropdown-time" :class="{'disabled': disabled}">
        <div class="has-feedback">
            <span class="form-control-feedback"><i class="far fa-clock"></i></span>
            <button
                    class="btn btn-block btn-outline-default text-transform-none dropdown-toggle text-left rounded-1"
                    type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            >
                <span v-if="formatText" class="flex-fill text-color-lightgrey d-flex justify-content-between align-items-center">
                    {{formatText}} <span v-if="available_places >= 0" class="available-places-text">
                        <span v-if="available_places > 0">
                            {{available_places}} post<span v-if="available_places > 0">i</span><span v-else>o</span> disponibili
                        </span>
                        <span v-else>sold out</span>
                    </span>
                </span>
                <span v-else>Seleziona l'ora</span>
                <i class="fas"></i>
            </button>
            <div ref="dropdown" class="dropdown-menu rounded-1" aria-labelledby="dropdownMenuButton">
                <div
                        v-for="range in times"
                        class="dropdown-item range--time__item text-center font-weight-bold"
                        @click="onSelect(range)"
                        :class="{'selected-item text-primary': isSelected(range)}"
                >
                    {{getRangeTimes(range)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'time',
            event: 'update'
        },
        props: ['times', 'time', 'disabled'],
        data() {
            return {
                available_places: null,
                formatText: ''
            }
        },
        watch: {
            time(val) {
                this.$set(this, 'formatText', val)
            },
            times(values) {
                if (values.length > 0) {
                    this.onSelect(values[0])
                }
            }
        },
        mounted() {
            this.$bus.$on('update-available-places', (payload) => {
                this.$set(this, 'available_places', payload)
            })
        },
        created() {
            this.$bus.$on('open-time-picker', this.openDropdown)
        },
        methods: {
            openDropdown() {
                $(this.$refs.dropdown).addClass('show')
            },
            getRangeTimes(range) {
                if (range.end_time)
                    return `${range.start_time.substr(0, 5)} - ${range.end_time.substr(0, 5)}`;
                return `${range.start_time.substr(0, 5)}`;
            },
            onSelect(range) {
                let start_time = range.start_time;
                let end_time = range.end_time || null;
                $(this.$refs.dropdown).removeClass('show');
                if (end_time)
                    this.$set(this, 'formatText', `${start_time.substr(0, 5)} - ${end_time.substr(0, 5)}`)
                else
                    this.$set(this, 'formatText', `${start_time.substr(0, 5)}`);
                this.$emit('update', this.formatText)
            },
            isSelected(range) {
                let start_time = range.start_time;
                let end_time = range.end_time || null;
                if (end_time) {
                    return this.time === `${start_time.substr(0, 5)} - ${end_time.substr(0, 5)}`
                }
                return this.time === `${start_time.substr(0, 5)}`
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationTimePicker.vue